export default {
  s: '%d seconde',
  smicro: '%d s',
  smid: '%d sec',

  ss: '%d secondes',
  ssmicro: '%d s',
  ssmid: '%d sec',

  m: '%d minute',
  mmicro: '%d m',
  mmid: '%d min',

  mm: '%d minutes',
  mmmicro: '%d min',
  mmmid: '%d min',

  h: '%d heure',
  hmicro: '%d h',
  hmid: '%d h',

  hh: '%d heures',
  hhmicro: '%d h',
  hhmid: '%d heures',

  d: '%d jour',
  dmicro: '%d j',
  dmid: '%d jour',

  dd: '%d jours',
  ddmicro: '%d j',
  ddmid: '%d jours',
};
